import { InteractionRequiredAuthError, PublicClientApplication } from "@azure/msal-browser";

const GRAPH_SCOPES = ["user.read", "Files.Read", "Files.Read.All", "Sites.Read.All"];

//DELETE ME
const LOGIN_PATH_KEY = "onsight.postLoginPath";
const appOrigin = import.meta.dev ? "http://localhost:3000" : window.location.origin;

const SHAREPOINT_ROOT =
  "https://graph.microsoft.com/v1.0/sites/onsightopt.sharepoint.com,0b7ae5c3-e106-467c-baa4-5bf7a2293d4b,9e6b34ba-1fc2-4a0b-a5a1-52d44f0c93ec/drives/b!w-V6CwbhfEa6pFv3oik9S7o0a57CHwtKpaFS1E8Mk-yMxiJJXfLiQ76l5m7ph5xA/root";

export default defineNuxtPlugin(async () => {
  if (!import.meta.client) {
    return;
  }

  const runtimeConfig = useRuntimeConfig();
  const authConfig = runtimeConfig.public.auth;
  const apiScopes = [authConfig.apiScope];

  const msalInstance = new PublicClientApplication({
    auth: {
      clientId: authConfig.clientId,
      authority: `https://login.microsoftonline.com/${authConfig.tenantId}/`,
      navigateToLoginRequestUrl: false,
      redirectUri: authConfig.redirectUri,
      postLogoutRedirectUri: authConfig.postLogoutRedirectUri,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  });

  await msalInstance.initialize();

  // try {
  //   await msalInstance.handleRedirectPromise();
  // } catch (error) {
  //   console.error("Error during token handling:", error);
  // }
  let redirectResult = null;

  try {
    redirectResult = await msalInstance.handleRedirectPromise();
  } catch (error) {
    console.error("Error during token handling:", error);
  }

  if (redirectResult && redirectResult.account) {
    msalInstance.setActiveAccount(redirectResult.account);
  } else {
    const existing = msalInstance.getAllAccounts();
    if (existing.length > 0) {
      msalInstance.setActiveAccount(existing[0]);
    }
  }

  // const pendingPath = sessionStorage.getItem(LOGIN_PATH_KEY);
  // if (pendingPath && msalInstance.getAllAccounts().length > 0) {
  //   const pendingPathname = pendingPath.split("?")[0];
  //   if (window.location.pathname !== pendingPathname) {
  //     sessionStorage.removeItem(LOGIN_PATH_KEY);
  //     window.location.replace(pendingPath);
  //     return;
  //   }
  //   sessionStorage.removeItem(LOGIN_PATH_KEY);
  // }

  const pendingPath = sessionStorage.getItem(LOGIN_PATH_KEY);
  if (pendingPath && msalInstance.getAllAccounts().length > 0) {
    const pendingPathname = pendingPath.split("?")[0];
    if (window.location.pathname !== pendingPathname) {
      sessionStorage.removeItem(LOGIN_PATH_KEY);
      window.location.replace(pendingPath);
    } else {
      sessionStorage.removeItem(LOGIN_PATH_KEY);
    }
  }


  await new Promise((resolve) => setTimeout(resolve, 100));

  // Wait to ensure account is available after redirect
  //await new Promise(resolve => setTimeout(resolve, 100));

  //const getAccount = () => msalInstance.getAllAccounts()[0] || null;
  const getAccount = () => msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0] || null;

  const acquireToken = async (scopes, interactive = false) => {
    let account = getAccount();

    // If no account, wait for it (useful during redirect flow)
    let retries = 0;
    while (!account && retries < 5) {
      await new Promise(resolve => setTimeout(resolve, 200));
      account = getAccount();
      retries++;
    }

    if (!account) return null;

    const request = { account, scopes };

    try {
      return await msalInstance.acquireTokenSilent(request);
    } catch (error) {
      if (interactive && error instanceof InteractionRequiredAuthError) {
        return await msalInstance.acquireTokenPopup(request);
      }

      if (interactive) {
        throw error;
      }

      console.error("Silent token acquisition failed:", error);
      return null;
    }
  };

  const getToken = async () => {
    const response = await acquireToken(GRAPH_SCOPES);
    return response?.accessToken || null;
  };

  const getAccessToken = async () => {
    const response = await acquireToken(apiScopes, true);
    return response?.accessToken || null;
  };

  // const login = async () => {
  //   try {
  //     await msalInstance.loginRedirect({
  //       scopes: [...new Set([...GRAPH_SCOPES, ...apiScopes])],
  //     });
  //   } catch (error) {
  //     console.error("Login failed:", error);
  //   }
  // };
  const login = async (targetPath = "/portal") => {
    try {
      sessionStorage.setItem(LOGIN_PATH_KEY, targetPath);

      await msalInstance.loginRedirect({
        scopes: [...new Set([...GRAPH_SCOPES, ...apiScopes])],
        redirectUri: `${appOrigin}/portal`,
        redirectStartPage: `${appOrigin}${targetPath}`,
      });
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  const logout = async () => {
    const account = getAccount();
    if (account) {
      await msalInstance.logoutRedirect({ account });
    }
  };

  const fetchGraphJson = async (url, errorMessage) => {
    const token = await getToken();
    if (!token) {
      return null;
    }

    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      console.error(errorMessage, response.statusText);
      return null;
    }

    return response.json();
  };

  const fetchGraphBlobUrl = async (url, errorMessage) => {
    const token = await getToken();
    if (!token) {
      return { url: null };
    }

    try {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        console.error(errorMessage, response.statusText);
        return { url: null };
      }

      const blob = await response.blob();
      return { url: URL.createObjectURL(blob) };
    } catch (error) {
      console.error(errorMessage, error);
      return { url: null };
    }
  };

  const profileInfo = () =>
    fetchGraphJson("https://graph.microsoft.com/v1.0/me", "Failed to fetch profile info:");

  const memberGroup = () =>
    fetchGraphJson("https://graph.microsoft.com/v1.0/me/memberOf", "Failed to fetch member groups:");

  const fetchProfileImage = () =>
    fetchGraphBlobUrl("https://graph.microsoft.com/v1.0/me/photo/$value", "Failed to fetch profile image:");

  const storesFiles = () =>
    fetchGraphJson(`${SHAREPOINT_ROOT}/children`, "Failed to fetch stores files:");

  const storesMemo = () =>
    fetchGraphJson(`${SHAREPOINT_ROOT}:/Memo:/children`, "Failed to fetch stores memos:");

  const storesForms = () =>
    fetchGraphJson(`${SHAREPOINT_ROOT}:/Memo/Misc%20Forms:/children`, "Failed to fetch stores forms:");

  const storesRetailPricingLists = () =>
    fetchGraphJson(`${SHAREPOINT_ROOT}:/Memo/Lens%20Retail%20and%20Cost%20Pricing%20Lists:/children`, "Failed to fetch retail pricing lists:");

  const storesArchive = () =>
    fetchGraphJson(`${SHAREPOINT_ROOT}:/Memo/Archive:/children`, "Failed to fetch stores archive:");

  const storesSPIFF = () =>
    fetchGraphJson(`${SHAREPOINT_ROOT}:/SPIFF:/children`, "Failed to fetch stores spiffs:");

  const storesSPIFFArchive = () =>
    fetchGraphJson(`${SHAREPOINT_ROOT}:/SPIFF/Archive:/children`, "Failed to fetch stores spiffs archive:");

  const storesCheatSheets = () =>
  fetchGraphJson(`${SHAREPOINT_ROOT}:/Memo/Retail%20Pricing%20Cheat%20Sheets:/children`, "Failed to fetch retail pricing cheat sheet:");

  return {
    provide: {
      login,
      logout,
      getAccessToken,
      getToken,
      profileInfo,
      memberGroup,
      storesFiles,
      storesMemo,
      storesRetailPricingLists,
      storesArchive,
      storesForms,
      storesSPIFF,
      storesSPIFFArchive,
      fetchProfileImage,
      storesCheatSheets,
    },
  };
});
